module.exports = __webpack_public_path__ + "static/media/megaphone.0905ae68.svg";